<div class="modal-content">
    <div class="modal-header">
        Move location
        <button type="button" class="btn-close p-4" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body mb-0 pb-0">
        <p *ngIf="hasActiveMeters(data.entity.location)" class="text-danger">
            This location has active meters. Moving it will also move all associated meters and meter data.
            <span>Are you sure you want to continue?</span>
        </p>
    </div>
    <div class="row px-4 mt-0">
        <div class="col-12">
            <app-form-field label="New organisation" class="w-100">
                <app-search [minCharacters]="0" [(ngModel)]="data.entity.organisation" required
                            [searchFunction]="searchOrganisations"
                            [inputFormatter]="refDataUtils.organisationFormatter"
                            dataKey="info.name"
                            placeholder="Search for an organisation"
                            class="w-100">
                </app-search>
            </app-form-field>
        </div>
    </div>
    <div class="modal-footer justify-content-between">
        <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
        <button type="button" class="btn btn-primary" (click)="moveLocation()" data-bs-dismiss="modal">
            Move location
        </button>
    </div>
</div>
